import apiFetch from '../../apiFetch'

export default function (stockDossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/rejectDossierBudget/${stockDossierId}`, method: 'PUT', token: token, lastAccessDate })
}
